<template>
  <modal name="update-customer" class="modal-inner modal-update-customer" transition="pop-out" :width="modalWidth" :focus-trap="true" :min-height="600" height="auto" :scrollable="true">
    <span class="close-button" @click="hide('update-customer')"><BaseIcon icon="times-circle" class="text-white"/></span>
    <div class="modal-header text-lg bg-primary-50 font-serif">
      <span v-if="customerInfo">{{ customerInfo.name }}</span>
    </div>
    <div class="modal-body">
      <ValidationObserver ref="formUpdateCustomer" v-if="updateInfo != null">
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.name" type="text" :field_name="$t('customer_update_modal.fields.name')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.company_number" type="text" :field_name="$t('customer_update_modal.fields.org_number')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full text-sm font-bold italic px-2 mb-4">
            {{ $t('customer_update_modal.sections.postal_address') }}
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.address" type="text" :field_name="$t('customer_update_modal.fields.address')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.zip_code" type="text" :field_name="$t('customer_update_modal.fields.zip_code')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.city" type="text" :field_name="$t('customer_update_modal.fields.city_town')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full text-sm font-bold italic px-2 mb-4">
            {{ $t('customer_update_modal.sections.billing_address') }}
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.billing_address" type="text" :field_name="$t('customer_update_modal.fields.billing_address')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.billing_zip_code" type="text" :field_name="$t('customer_update_modal.fields.billing_zip_code')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.billing_city" type="text" :field_name="$t('customer_update_modal.fields.billing_city')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.billing_reference" type="text" :field_name="$t('customer_update_modal.fields.billing_reference')" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.billing_invoice" type="text" :field_name="$t('customer_update_modal.fields.billing_invoice')" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full text-sm font-bold italic px-2 mb-4">
            {{ $t('customer_update_modal.sections.contact_details') }}
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.contact_name" type="text" :field_name="$t('customer_update_modal.fields.contact_person')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.phone" type="text" :field_name="$t('customer_update_modal.fields.phone')" rules="required" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseInput v-model="updateInfo.email" type="text" :field_name="$t('customer_update_modal.fields.email')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 px-2">
            <BaseTextarea rows="5" v-model="updateInfo.unit_description" :field_name="$t('customer_update_modal.fields.customer_description')" />
          </div>
          <div class="w-full md:w-1/2 px-2">
            <BaseSelect v-model="updateInfo.alarm_central" :options="alarmCenters" optionSelector="_id" nameSelector="name" :field_name="$t('customer_update_modal.fields.alarm_center')" rules="required" :disabled="reseller && reseller.alarm_center != ''" :readonly="reseller && reseller.alarm_center != ''" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2" v-if="user.role == 'admin'">
            <BaseSelect v-model="updateInfo.seller" :options="sellers" optionSelector="_id" nameSelector="name" :field_name="$t('customer_update_modal.fields.seller')" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2" v-if="user.role == 'admin' && securOneEnabled">
            <BaseInput v-model="updateInfo.securone_licenses" type="number" min="0" step="1" :field_name="$t('customer_update_modal.fields.securone_licenses')" rules="numeric" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2" v-if="showCountryOrigin">
            <BaseSelect v-model="updateInfo.country_origin" :options="countryOriginOptions" optionSelector="id" nameSelector="name" :field_name="$t('country_origin.label')" />
            <p v-if="updateInfo.country_origin === 'nl'" class="text-xs text-gray-500 mt-1">{{ $t('country_origin.nl_hint') }}</p>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <div class="modal-footer">
      <div class="footer-container clearfix">
        <button class="btn-red-outline px-3 py-2 float-left" @click="hide('update-customer')">{{ $t('customer_update_modal.buttons.cancel') }}<BaseIcon icon="times-circle" class="ml-1" /></button>
        <button class="btn-green px-3 py-2 float-right" @click="updateCustomer()">{{ $t('customer_update_modal.buttons.save') }}<BaseIcon icon="save" class="ml-1" /></button>
      </div>
    </div>
  </modal>
</template>

<script>
import { canSetCountryOrigin, countryOriginOf, countryOriginOptions } from "@/utils/countryOrigin";

const MODAL_WIDTH = 800;

export default {
  props: {
    customerInfo: {
      required: true,
      default: null,
    },
    alarmCenters: {
      required: true,
      default: null,
    },
    sellers: {
      required: true,
      default: null,
    },
    reseller: {
      default: null,
    },
  },
  data() {
    return {
      updateInfo: null,
      // the country the form opened with (only a change is saved)
      initialCountryOrigin: null,
      // SecurOne licences are edited only where the add-on is active on the
      // customer or on one of its units (the list row does not know the units)
      securOneEnabled: false,
    };
  },
  watch: {
    customerInfo(newVal) {
      // eslint-disable-line
      const info = _.cloneDeep(newVal);
      if (info) info.country_origin = countryOriginOf(info);
      this.updateInfo = info;
      this.initialCountryOrigin = info ? info.country_origin : null;
      this.checkSecurOne(newVal);
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    // admins and sellers, on a customer of the Swedish portal
    showCountryOrigin() {
      return !!this.updateInfo && canSetCountryOrigin(this.user, this.updateInfo.country);
    },
    countryOriginOptions() {
      return countryOriginOptions((key) => this.$t(key));
    },
  },
  methods: {
    hasSecurOneAddon(doc) {
      return Array.isArray(doc && doc.addons) && doc.addons.some((a) => String(a).toLowerCase() === "securone");
    },
    checkSecurOne(customer) {
      this.securOneEnabled = this.hasSecurOneAddon(customer);
      if (!customer || !customer._id || this.user.role != "admin") return;
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/addons/customer/${customer._id}`)
        .then((response) => {
          if (!this.updateInfo || String(this.updateInfo._id) != String(customer._id)) return;
          this.securOneEnabled = this.hasSecurOneAddon(response.data.customer) || (response.data.units || []).some(this.hasSecurOneAddon);
        })
        .catch(() => {});
    },
    updateCustomer() {
      this.$refs.formUpdateCustomer.validate().then((success) => {
        if (!success) {
          return;
        }

        let data = {
          name: this.updateInfo.name,
          company_number: this.updateInfo.company_number,
          address: this.updateInfo.address,
          zip_code: this.updateInfo.zip_code,
          city: this.updateInfo.city,
          billing_address: this.updateInfo.billing_address,
          billing_zip_code: this.updateInfo.billing_zip_code,
          billing_city: this.updateInfo.billing_city,
          billing_reference: this.updateInfo.billing_reference,
          billing_invoice: this.updateInfo.billing_invoice,
          contact_name: this.updateInfo.contact_name,
          phone: this.updateInfo.phone,
          email: this.updateInfo.email,
          unit_description: this.updateInfo.unit_description,
          alarm_central: this.updateInfo.alarm_central,
          seller: this.updateInfo.seller,
        };
        if (this.user.role == "admin" && this.securOneEnabled) {
          const n = this.updateInfo.securone_licenses;
          data.securone_licenses = n === "" || n === null || n === undefined ? null : Number(n);
        }
        // only a changed country is sent: a list that did not load it shows Sverige and
        // must not overwrite a Dutch customer's
        if (this.showCountryOrigin && this.updateInfo.country_origin !== this.initialCountryOrigin) {
          data.country_origin = this.updateInfo.country_origin;
        }

        this.axios
          .put(`${process.env.VUE_APP_SERVER_URL}/customer/${this.updateInfo._id}`, data)
          .then((response) => {
            //eslint-disable-line
            this.$emit("updateCustomer");
            this.$modal.hide("update-customer");
            // SEC-385: say what reached Safe-4, when the save sent anything there
            if (!this.showSafe4SyncResult(response.data && response.data.safe4)) this.handleSuccess();
          })
          .catch((error) => {
            this.handleError(error);
          });
      });
    },

    hide(id) {
      this.$refs.formUpdateCustomer.reset();
      this.$modal.hide(id);
    },
  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;
  },
};
</script>
